import { v4 as uuidv4 } from 'uuid';
import { supabase } from './supabaseClient';

export function generateShortCode() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 6; i++) code += chars[Math.floor(Math.random() * chars.length)];
  return code;
}

export async function createGame(settings) {
  const id = uuidv4();
  const short_code = generateShortCode();

  const game = {
    id,
    short_code,
    home_team_name: settings.homeTeam,
    away_team_name: settings.awayTeam,
    umpire_name: settings.umpireName || '',
    status: 'active',
    home_score: 0,
    away_score: 0,
    current_inning: 1,
    is_top_inning: true,
    balls: 0,
    strikes: 0,
    outs: 0,
    base_1: false,
    base_2: false,
    base_3: false,
    max_innings: settings.maxInnings || 7,
    max_strikes: settings.maxStrikes || 3,
    max_balls: settings.maxBalls || 4,
    max_outs: settings.maxOuts || 3,
    mercy_enabled: settings.mercyEnabled || false,
    mercy_runs: settings.mercyRuns || 7,
    game_mercy_enabled: settings.gameMercyEnabled || false,
    game_mercy_runs: settings.gameMercyRuns || 15,
    inning_run_count: 0,
    time_limit_enabled: settings.timeLimitEnabled || false,
    time_limit_minutes: settings.timeLimitMinutes || 60,
    timer_running: false,
    timer_started_at: null,
  };

  const { error } = await supabase.from('games').insert(game);
  if (error) throw error;
  return game;
}

export async function getGameByCode(code) {
  const { data, error } = await supabase
    .from('games')
    .select('*')
    .eq('short_code', code.toUpperCase())
    .single();
  if (error) throw error;
  return data;
}

export async function getInningScores(gameId) {
  const { data } = await supabase
    .from('inning_scores')
    .select('*')
    .eq('game_id', gameId)
    .order('inning', { ascending: true });
  return data || [];
}

export async function updateGame(gameId, updates) {
  const { error } = await supabase.from('games').update(updates).eq('id', gameId);
  if (error) throw error;
}

export async function upsertInningScore(gameId, inning, team, runs) {
  const { data: existing } = await supabase
    .from('inning_scores')
    .select('id')
    .eq('game_id', gameId)
    .eq('inning', inning)
    .eq('team', team)
    .single();

  if (existing) {
    await supabase.from('inning_scores').update({ runs }).eq('id', existing.id);
  } else {
    await supabase.from('inning_scores').insert({ game_id: gameId, inning, team, runs });
  }
}

export async function logEvent(gameId, type, description, inning, isTop) {
  await supabase.from('game_events').insert({
    game_id: gameId,
    event_type: type,
    description,
    inning,
    is_top: isTop,
  });
}
